import { h } from "@stencil/core";
export class MobileTable {
    constructor() {
        this.uxTable = undefined;
        this.sortable = false;
        this.selectLabel = "";
        this.noClickSelector = "";
        this.rows = [];
        this.sorters = [];
    }
    table = null;
    /** this should be called when the source content is changed */
    async update() {
        if (this.uxTable == null) {
            return;
        }
        this.table = this.uxTable.querySelector("table");
        if (this.table == null) {
            return;
        }
        this.rows = Array.from(this.table.querySelectorAll("tr:not(thead tr)")).filter((tr) => tr.querySelector("td") !== null);
        const sortElements = Array.from(this.table.querySelectorAll("th ux-table-sort"));
        this.sorters = [];
        sortElements.forEach((el) => {
            this.sorters.push({
                text: el.textContent + " ↓",
                trigger: () => el.sortDesc(),
                selected: el.sortedDirection === "desc"
            });
            this.sorters.push({
                text: el.textContent + " ↑",
                trigger: () => el.sortAsc(),
                selected: el.sortedDirection === "asc"
            });
        });
    }
    componentDidLoad() {
        this.update();
    }
    render() {
        if (this.table === null) {
            return null;
        }
        const titleColIndex = 
        // @ts-expect-error Check for typing
        this.uxTable.mobileTitleIndex === undefined ? this.uxTable.fixedColIndex : this.uxTable.mobileTitleIndex;
        const columnTitles = Array.from(this.table.querySelectorAll("tr th"));
        const columnTitlesFiltered = columnTitles.filter(
        // @ts-expect-error Check for typing
        (title) => title !== this.table.querySelector(`tr th:nth-child(${titleColIndex + 1})`));
        const ColumnTitlesHtml = columnTitlesFiltered.map((title) => {
            const sorter = title.querySelector(".ux-table-sort__text");
            if (sorter !== null) {
                return sorter.innerHTML;
            }
            return title.innerHTML;
        });
        const fixedColTitle = this.table.querySelector(`th:nth-child(${titleColIndex + 1})`);
        // @ts-expect-error Check for typing
        const fixedSorter = fixedColTitle.querySelector(".ux-table-sort__text");
        // @ts-expect-error Check for typing
        const fixedColTitleHtml = fixedSorter !== null ? fixedSorter.innerHTML : fixedColTitle.innerHTML;
        const baseClass = "ux-mobile-table";
        return (h("div", { class: baseClass }, this.sortable && (h("ux-select", { class: `${baseClass}__select`, label: this.selectLabel, onUxSelectChange: (e) => {
                const filteredSorters = this.sorters.filter((sorter) => sorter.text === e.detail);
                if (filteredSorters.length > 0) {
                    const sorter = filteredSorters[0];
                    sorter.trigger();
                }
            } }, this.sorters.map((sorter) => (h("option", { selected: sorter.selected }, sorter.text))))), this.rows.map((row) => {
            const accordionTitle = row.querySelector(`td:nth-child(${titleColIndex + 1})`);
            const cells = Array.from(row.querySelectorAll(`td`));
            const cellsFiltered = cells.filter((cell) => cell !== row.querySelector(`td:nth-child(${titleColIndex + 1})`));
            return (h("ux-accordion", { class: `${baseClass}__accordion`, "no-click-selector": this.noClickSelector }, h("span", { slot: "title", class: `${baseClass}__accordion-title` }, fixedColTitle !== null ? (h("span", { innerHTML: fixedColTitleHtml, class: "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-margin-bottom-5" })) : (h("span", null)), accordionTitle !== null ? h("span", { innerHTML: accordionTitle.innerHTML }) : h("span", null)), h("table", { class: `${baseClass}__accordion-table` }, cellsFiltered.map((cell, index) => {
                return (h("tr", { class: `${baseClass}__accordion-row` }, h("span", { innerHTML: ColumnTitlesHtml[index], class: "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-margin-bottom-5" }), h("span", { innerHTML: cell.innerHTML })));
            }))));
        })));
    }
    static get is() { return "ux-mobile-table"; }
    static get originalStyleUrls() {
        return {
            "$": ["mobile-table.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["mobile-table.css"]
        };
    }
    static get properties() {
        return {
            "uxTable": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLUxTableElement | null",
                    "resolved": "HTMLUxTableElement | null",
                    "references": {
                        "HTMLUxTableElement": {
                            "location": "global",
                            "id": "global::HTMLUxTableElement"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "ux-table element"
                }
            },
            "sortable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "is table sortable"
                },
                "attribute": "sortable",
                "reflect": false,
                "defaultValue": "false"
            },
            "selectLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "label for ux-select"
                },
                "attribute": "select-label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "noClickSelector": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "choose no-click-selector if an icon (other than the accordion icon) is used in the fixed-mobile-col"
                },
                "attribute": "no-click-selector",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "rows": {},
            "sorters": {}
        };
    }
    static get methods() {
        return {
            "update": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "HTMLUxTableSortElement": {
                            "location": "global",
                            "id": "global::HTMLUxTableSortElement"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "this should be called when the source content is changed",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=mobile-table.js.map
